import React, { useContext, useEffect } from 'react'
import './registrationCompleted.css'
import { appContext } from '../../service/AppContext'
import Button from '../buttons/Button';

export default function RegistrationCompleted() {

    const { navigate, setUser, user } = useContext(appContext);

    useEffect(() => {
        // Purge the persisted simulator kids (keyed by email) before wiping the
        // email, so a back-navigation to the simulator can't restore them.
        if (user?.email) localStorage.removeItem(user.email);
        setUser({ firstName: '', lastName: '', email: '', phone: '', personId: '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNavigate = () => {
        window.location.assign('https://glb.org.il/');
    }

    return (
        <div className='registration-completed'>
            <div className='completed-wrapper'>
                <img src="./icons/document-check.svg" alt='registration completed ✓' />
                <div  role="heading" aria-level="2" className='heading-h3'>בקשת ההצטרפות הושלמה בהצלחה.</div>
                {/* <p className='sub-header'>טופס בקשת ההצטרפות לגמ״ח הושלמה בהצלחה. נציג שלנו יצור איתכם קשר בהקדם לצורך השלמת התהליך ואישורו הסופי</p> */}
            </div>
            <Button label='חזרה לעמוד הבית' onClick={handleNavigate} />
        </div>
    )
}
